export const FETCH_SITES_SUCCESS = 'FETCH_SITES_SUCCESS';
export const UPDATE_ACTIVE_SORT_FIELD_SITES_M = 'UPDATE_ACTIVE_SORT_FIELD_SITES_M';
export const UPDATE_SEARCH_SITES_M = 'UPDATE_SEARCH_SITES_M';
export const CLEAR_SEARCH_SITES_M = 'CLEAR_SEARCH_SITES_M';
export const TOGGLE_NOT_LINKED_FILTER_M = 'TOGGLE_NOT_LINKED_FILTER_M';
